import hrms19xLabels from 'assets/labels/hrms19x'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hrms19xLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codpos: faker.random.word(),
        desc_codcomp: faker.random.words(),
        dtework: moment().format('DD/MM/YYYY'),
        typwork: 'W',
        codshift: 'D1',
        timstrtw: moment().format('HH:mm'),
        timendw: moment().format('HH:mm'),
        timin: moment().format('HH:mm'),
        timout: moment().format('HH:mm'),
        timinc: moment().format('HH:mm'),
        timoutc: moment().format('HH:mm'),
        qtylate: '',
        qtyearly: '',
        qtyabsent: '',
        desc_codchng: '',
        qtyleave: '',
        ot_before: '',
        ot_during: '',
        ot_after: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms19x/mocker.js